<template>
  <DxPopup @hidden="onHidden" :visible="showProcessEPop" :show-close-button="true" :show-title="true" :title="menuTitle" height="850" width="1280" container=".v-application">
    <div class="h-full">
      <DxScrollView
        width="100%"
        height="100%"
        direction="both"
      >
        <OL type="A" style="font-size:12pt;">
          <LI>Website Information - http://ebiz.hvs.com.vn</LI>
            <OL type="1" style="font-size:10pt;">
              <LI>Users : all suppliers have commercial relation with HD Hyundai VietNam ShipBuilding Co., Ltd.(HVS).</LI>
              <LI>Internet Explore Setting</LI>
                <OL type="i" style="font-size:10pt;">
                  <LI>
                    Add 'http://*.ebiz.hvs.com.vn' to Trusted sites.<br>
                    (1)Open Internet Option and select Security<br>
                    <img :src="require(`@/assets/images/etc/ie_setting_00_Option.jpg`)" width="600"><br>
                    (2)Add Trusted sites<br>
                    <img :src="require(`@/assets/images/etc/ie_setting_00_setting.jpg`)" width="300"><br>
                  </LI>
                  <LI>
                    Turn Off pop-up Blockers : You must turn off IE's Pop-up Blockers as follow image.<br>
                    <img :src="require(`@/assets/images/etc/ie_setting_01_turnoff_popup.jpg`)" width="600"><br>
                    or set internet option as follow images.<br>
                    <img :src="require(`@/assets/images/etc/ie_setting_02_Option.jpg`)" width="600"><br>
                    <img :src="require(`@/assets/images/etc/ie_setting_03_set_blocker.jpg`)" width="600"><br><br>
                  </LI>
                  <LI>
                    Dont' use toolbar. (ex, Google toolbar, Yahoo toolbar) - If you use the toolbar, the toolbar can protect pop-up.<br>
                    <img :src="require(`@/assets/images/etc/ie_setting_04_toolbar.jpg`)" width="600"><br><br>
                  </LI>
                </OL>
              <LI>Login : USER ID and PASSWORD</LI>
                <OL type="i" style="font-size:10pt;">
                  <LI>USER ID:</LI>
                    <OL type="a" style="font-size:10pt;">
                      <LI>USER ID is a supplier code which is created by HVS(Each supplier code, Exp:Supplier code of A company is 10001, B company is 10002, ...).</LI>
                      <LI>
                        If customers do not have a customer code, please contact us at :<br>
                        Purchase Section, Procurement Department, HD Hyundai VietNam ShipBuilding Co., Ltd.<br>
                        No. 01, Mỹ Giang, Ninh Phước, Ninh Hòa, Khán Hòa, Việt Nam,<br>
                        Tel : 0583.622101, Fax : 0583.622047, E-mail : hvs@hvs.com.vn
                      </LI>
                    </OL>
                  <LI>PASSWORD:</LI>
                    <OL type="a" style="font-size:10pt">
                      <LI>First password for a new user : v + customer code (exp: USER ID : 10001, PASSWORD : 10001).</LI>
                      <LI>You can change to new password by yourself from current password.</LI>
                      <LI>You must be change to new password for every 3 months.</LI>
                      <LI>If you lose or forget your password, in this case the supplier must come to our company directly and bring documents relating to your company to prove with Material department before Material department create a new password(in order to the information security of users.).</LI>
                    </OL>
                  <LI>The purpose of the Quotation request to find a supplier with price and technical standards of the purchase of materials to suit the available cost and made good quality of our products.<br><br></LI>
                </OL>
            </OL>
          <LI>Processing of Website:</LI>
            <OL type="1" style="font-size:10pt;">
              <LI>Quotation Request : Our company will select some potentiality supplier to send quotaation request via this site.</LI>
                <OL type="i" style="font-size:10pt;">
                  <LI>Each Quotation request has Quotation No. as follow : QT + YY(year) + MM(month) + '-' + serial (QT0905-0001).</LI>
                  <LI>Receipt Quotation request from us.</LI>
                  <LI>Make Quotation before you send to us(Keep deadline).</LI>
                  <LI>After save(or submit) quotation information, the information will be encrypt.</LI>
                  <LI>After save(or submit) quotation information, you can not change or delete information.</LI>
                  <LI>We will compare quotation between the suppliers if the price difference is too high price will conduct a quotation request to the suppliers to create better quotation, otherwise we will send to you a price indication request.<br><br></LI>
                </OL>
              <LI>Re-Quotation :</LI>
                <OL type="i" style="font-size:10pt;">
                  <LI>Receipt Re-quotation request.</LI>
                  <LI>Make quotation before you send to us (keep deadline).</LI>
                  <LI>After save quotation information, the information will be encrypted and you can not change or delete information.<br><br></LI>
                </OL>
              <LI>P/I(Price Indication) : HVS will send to you a  target price in order to price indication.</LI>
                <OL type="i" style="font-size:10pt;">
                  <LI>Receipt Quotation request of price indication from our company.</LI>
                  <LI>Make quotation and send to our company (keep deadline).</LI>
                  <LI>After save quotation information, the information will be encrypted and you can not change or delete information. </LI>
                  <LI>If more than one customer with prices equal or all customers have higher price with our target price, our company will make the bidding process, contrary our company will select supplier that price equal to or lower than our target price for making purchase order sheet.<br><br></LI>
                </OL>
              <LI>Bid :</LI>
                <OL type="i" style="font-size:10pt;">
                  <LI>Receipt Quotation request of bidding.</LI>
                  <LI>Make Quotation request and send to our company (keep deadline).</LI>
                  <LI>After save quotation information, the information will be encrypted and you can not change or delete information.</LI>
                  <LI>If more than one customer with prices equal, we will Re-bidding, contrary our company will choose supplier that the lowest price for making purchase order sheet.<br><br></LI>
                </OL>
              <LI>Re-Bid :</LI>
                <OL type="i" style="font-size:10pt;">
                  <LI>Receipt Quotation request of bidding.</LI>
                  <LI>Make Quotation request and send to our company (keep deadline).</LI>
                  <LI>After save quotation information, the information will be encrypted and you can not change or delete information.</LI>
                  <LI>If more than one customer with prices equal, we will invite those suppliers come to our company for negotiate and choose the supplier which have the lowest price.<br><br></LI>
                </OL>
              <LI>P.O(Purchase Order) :</LI>
                <OL type="i" style="font-size:10pt;">
                  <LI>After confirm price, we will send to your company a purchase order sheet (PO sheet).</LI>
                  <LI>Receipt purchase order sheet.</LI>
                  <LI>Make delivery note based on the terms agreed.<br><br></LI>
                </OL>
              <LI>Delivery :</LI>
                <OL type="i" style="font-size:10pt;">
                  <LI>Make delivery note based on purchase order information from our company.</LI>
                  <LI>When we purchase material to repair ship but the ship sail out before the supplier is making Delivery Note, in this case, the Purchaser must report to General Manager of Material department to consider and make a decision, the supplier can make a Delivery Note when General Manager of Material department was approved, otherwise the system will lock function to create new Delivery Note.</LI>
                  <LI>Customers must be delivered within 5 days as from create date of Delivery Note, if more than 5 days that the customer has not delivered the system will delete that Delivery Note automatically.</LI>
                  <LI>We are receiving goods when you have valid delivery note sheet and check delivery note information for actual material delivery. The valid delivery note sheet is not modify information by handwrite on it and actual delivery must same delivery note sheet. After warehousing for a delivery note, the system doesn’t permit for modifies information to Delivery Note.<br><br></LI>
                </OL>
            </OL>
        </OL>
      </DxScrollView>
    </div>
  </DxPopup>
</template>

<script>
import baseview from '@/components/base/baseview'
import { DxPopup } from 'devextreme-vue/popup'
import { DxScrollView } from 'devextreme-vue/scroll-view'

export default {
  name: 'processEPop',
  mixins: [baseview],
  components: {
    DxPopup,
    DxScrollView
  },
  props: {
    showProcessEPop: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  data() {
     return {
       menuTitle: 'Hip Process(English)',
       openChk: false
     }
  },
  watch: {
    'showProcessEPop': {
      handler(value, oldValue) {
        if(value) {
          this.init()
        }
      },
      immediate: true
    }
  },
  methods: {
    init() {
    },
    onHidden(e) {
      this.$emit('update:showProcessEPop', false)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>